export const buildListDropdownOption = machine_name => {
  let option = {
    type: "list",
    text: null,
    machine_name: machine_name,
  }

  switch (machine_name) {
    case "documents":
    case "polls":
    case "surveys":
    case "questionnaires":
      option.text =
        machine_name.substr(0, 1).toUpperCase() +
        machine_name.substr(1, machine_name.length - 2) +
        " List"
      break

    case "lists":
      option.text = "List of Lists"
      break

    case "custom_web_links":
      option.text = "Web Link List"
      break

    case "trivia_challenge":
      option.text = "Trivia Challenge List"
      break

    case "comment_board":
      option.text = "Comment Board"
      break

    case "guest_list":
      option.text = "Attendee List"
      break

    case "private_message":
      option.text = "Private Messages"
      break

    case "leaderboard":
    case "livestream":
    case "camera":
      option.text =
        machine_name.substr(0, 1).toUpperCase() + machine_name.substr(1)
      break

    case "media":
      option.text = "Media Gallery"
      break

    case "countdown_clock":
      option.text = "Countdown Clock List"
      break

    case "calendar":
      option.text = "View Calendar Events"
      break

    case "register_guest":
      option.text = "Register Visitors"
      break

    case "refer_friend":
      option.text = "Refer a Friend"
      break

    case "booking_service":
      option.text = "Booking - Create a Booking"
      break

    case "view_bookings":
      option.text = "Booking - View Bookings"
      break

    case "form_builders":
      option.text = "Form Builder List"
      break

    case "places":
      option.text = "Places"
      break

    case "video_call":
      option.text = "Video Call"
      break

    default:
      option = null
      break
  }

  return option
}

export const buildSingleItemDropdownOption = machine_name => {
  let singleItem = {
    type: "entity",
    text: null,
    machine_name: machine_name,
  }

  switch (machine_name) {
    case "countdown_clock":
    case "trivia_challenge":
    case "basic_content":
      var txt1 = machine_name.replace(/_/g, " ")
      singleItem.text = txt1.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
      })
      break

    case "documents":
    case "polls":
    case "surveys":
    case "lists":
    case "questionnaires":
      singleItem.text =
        machine_name.substr(0, 1).toUpperCase() +
        machine_name.substr(1, machine_name.length - 2)
      break

    case "custom_web_links":
      singleItem.text = "Web Link"
      break

    case "event_info":
      singleItem.text = "Event Info / RSVP"
      break

    case "form_builders":
      singleItem.text = "Form Builder"
      break

    default:
      singleItem = null
      break
  }

  return singleItem
}

export const mapApiResponseToForm = (apiResponse = {}) => ({
  layout: {
    layout: apiResponse?.template_id?.toString(),
  },
  button: {
    button_text: apiResponse?.my_events_text,
    requireLogIn: apiResponse?.my_events_require_log_in === 1,
    button_color: apiResponse?.my_events_tab_color,
    text_color: apiResponse?.my_events_font_color,
  },
  background: {
    bgImage: {
      editedImage: apiResponse?.bg_image_url,
    },
  },
  header: {
    header_color: apiResponse?.header_bg_color,
    title: apiResponse?.logo_text,
    font: apiResponse?.logo_font_family,
    font_color: apiResponse?.logo_font_color,
    header_type: apiResponse?.logo_text || apiResponse?.logo ? "2" : "1",
    logoImage: { editedImage: apiResponse?.logo },
  },
  menu: {
    style: {
      menu_tab_color: apiResponse?.menu_bg_color,
      menu_text_color: apiResponse?.menu_font_color,
      menu_font: apiResponse?.menu_font_family,
    },
  },
})

export const mapFormToApi = (formValues = {}) => ({
  template_id: formValues?.layout?.layout,
  my_events_text: formValues?.button?.button_text,
  my_events_require_log_in: formValues?.button?.requireLogIn ? 1 : 0,
  my_events_tab_color: formValues?.button?.button_color,
  my_events_font_color: formValues?.button?.text_color,
  header_bg_color:
    formValues?.header?.header_type == "1"
      ? null
      : formValues?.header?.header_color,
  logo_text: formValues?.header?.title,
  logo_font_family: formValues?.header?.font,
  logo_font_color: formValues?.header?.font_color,
  menu_bg_color: formValues?.menu?.style?.menu_tab_color,
  menu_font_color: formValues?.menu?.style?.menu_text_color,
  menu_font_family: formValues?.menu?.style?.menu_font,
  title_type: formValues?.header?.logoImage?.editedImage
    ? "logo"
    : formValues?.header?.title
    ? "text"
    : "none",
  ...(formValues?.header?.deleteLogo &&
  !formValues?.header?.logoImage?.editedImage
    ? { delete_logo_file: 1 }
    : {}),
})
